module.exports = {
      id: "logo-small-usage",
      viewBox: "0 0 192 28",
      url: __webpack_public_path__ + "svg-sprite-a2aa2e5b3e3b70ea2fa34e79b698feaf.svg#logo-small",
      toString: function () {
        return this.url;
      }
    }